// extracted by mini-css-extract-plugin
var _1 = "EmailProfileWidgetCopiedToContentSkeleton-moduleEmailProfileWidgetCopiedToContentSkeleton___EFme WidgetContentSkeleton-moduleWidgetContentSkeleton__eblVC";
var _2 = "EmailProfileWidgetCopiedToContentSkeleton-moduledivider__UTlWP Divider-moduleDivider__dL3Vg";
export { _1 as "EmailProfileWidgetCopiedToContentSkeleton", _2 as "divider" }
